import { Add as Add_kojaro } from './Add.kojaro';
import { Add as Add_zoomg } from './Add.zoomg';
import { Add as Add_zoomit } from './Add.zoomit';
import { Add as Add_phosphor } from './Add.phosphor';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Add_kojaro;

    case 'zoomg':
      return Add_zoomg;

    case 'phosphor':
      return Add_phosphor;


    default:
      return Add_zoomit;
  }
};

export const Add = IconRenderer();
